<template>
    <div class="reward-sigin-popup" v-if="isShow">
        <div class="popup-bg js-close-popup"></div>
        <div class="popup-content">
            <div class="popup-image">
                <img v-if="isSignIn" src="https://resource.rcclchina.com.cn/memberCenter/pc/hasSignedPopup.png">
                <div class="signInSuccess" v-else>
                    <img src="https://resource.rcclchina.com.cn/reward/sign_in_bg_pc.png"/>
                    <p>签到成功</p>
                    <h3>
                        <span class="cur"><i>+</i>{{signInPoint}}</span>积分
                    </h3>
                </div>
            </div>
            <div class="popup-close js-close-popup">
                <a @click="close">
                    <img src="https://resource.rcclchina.com.cn/memberCenter/pc/sigin-popup-close.png">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SignIn',
        props: {
            isSignIn: {
                type: Boolean,
                default: false,
            },
            signInPoint: {
                type: Number,
                default: 1
            }
        },
        data: () => {
            return {
                isShow: false
            }
        },
        methods: {
            show () {
                this.isShow = true
            },
            close () {
                this.isShow = false
            }
        }
    }
</script>

<style lang="less" scoped>
    .reward-sigin-popup {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 10;
    }

    .reward-sigin-popup .popup-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .reward-sigin-popup .popup-content {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .reward-sigin-popup .popup-content .popup-close {
        margin-top: 12px;
        cursor: pointer;
    }

    .signInSuccess {
        position: relative;
        width: 506px;
        height: 323px;
        text-align: center;
        color: #fff;
        margin: auto;
        img {
            position: absolute;
            width: 100%;
            left: 0;
        }
        p {
            padding-top: 30px;
            font-size: 30px;
            line-height: 40px;
            z-index: 1;
            position: relative;
        }
        h3 {
            z-index: 1;
            position: relative;
            display: block;
            height: 42px;
            font-size: 24px;
            font-weight: 400;
            line-height: 42px;
            .cur {
                position: relative;
                top: 4px;
                margin-right: 10px;
                font-size: 48px;
            }
            i {
                margin-right: 8px;
            }
        }
    }
</style>
